/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _default = function _default(columns, _ref) {
  var headerRegion = _ref.headerRegion,
    initialOffset = _ref.initialOffset,
    availableWidth = _ref.availableWidth,
    totalLockedEndWidth = _ref.totalLockedEndWidth,
    initialScrollLeft = _ref.initialScrollLeft,
    rtlOffset = _ref.rtlOffset,
    rtl = _ref.rtl;
  var lockedEndOffset = 0;
  var result = columns.map(function (c, i) {
    var _result;
    var computedLocked = c.computedLocked;
    var offset = rtl ? initialOffset - (initialScrollLeft || 0) - c.computedOffset : c.computedOffset + (initialOffset - (initialScrollLeft || 0));
    if (rtl) {
      offset += rtlOffset;
    }
    if (computedLocked === 'end') {
      offset = !rtl ? availableWidth - totalLockedEndWidth + lockedEndOffset + initialOffset : initialOffset - availableWidth + totalLockedEndWidth - lockedEndOffset;
      lockedEndOffset += c.computedWidth;
    }
    if (computedLocked === 'start') {
      offset = c.computedOffset + (initialOffset || 0);
    }
    var result = (_result = {}, (0, _defineProperty2.default)(_result, rtl ? 'right' : 'left', offset), (0, _defineProperty2.default)(_result, rtl ? 'left' : 'right', rtl ? offset - c.computedWidth : offset + c.computedWidth), (0, _defineProperty2.default)(_result, "width", c.computedWidth), (0, _defineProperty2.default)(_result, "computedLocked", computedLocked), (0, _defineProperty2.default)(_result, "index", i), _result);
    return result;
  });
  return result;
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/Layout/ColumnLayout/HeaderLayout/getRangesForColumns.js
// module id = 562
// module chunks = 0